import { type ServiceConfig } from '../../ServiceRegistry';
import { getBrowserAuthHeaders } from '@/lib/auth/browserAccessToken';

export const AUTHENTICATION_SERVICE_NAME = 'authenticationService';

/** Shape federated remotes resolve through `getService('authenticationService')`. */
export interface AuthenticationService {
  getAuthHeaders(): Promise<Record<string, string>>;
}

export const authenticationServices: ServiceConfig[] = [
  {
    name: AUTHENTICATION_SERVICE_NAME,
    factory: (): AuthenticationService => ({ getAuthHeaders: getBrowserAuthHeaders }),
  },
];
